import axios, { AxiosResponse } from 'axios';
import { IContactUsApiResponse, IContactUsReqData, IFeedbackReqData } from '../types/api/contactUsApi';
import { toast } from 'react-toastify';


const API_URL = process.env.REACT_APP_API_URL;

const customHeaders = {
    'Content-Type': 'application/json'
};

// Sign in function with typed parameters and response
export const submitContactUsDataService = async (data: IContactUsReqData): Promise<AxiosResponse<IContactUsApiResponse>> => {
    try {
        const response = await axios.post(`${API_URL}contact-us`, data, { headers: customHeaders });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        error.response && error.response.data.errors.forEach((err: any) => {
            toast.error(err.msg)
        })
        // You can toast an error message if needed
        // toast.error(error?.response?.data?.msg);
        throw error;
    }
};

export const submitFeedbackDataService = async (data: FormData): Promise<AxiosResponse<IContactUsApiResponse>> => {
    try {
        const response = await axios.post(`${API_URL}testimonials`, data, { headers:  {
            'Content-Type': 'multipart/form-data'
        } });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        error.response && error.response.data.errors.map((err:any)=>{

            toast.error(err.msg)
        })
        // You can toast an error message if needed
        // toast.error(error?.response?.data?.msg);
        throw error;
    }
};
